import * as types from '../actions/actionTypes';
export const cipGroups = (state = {Groups:[], Loading : true}, action) => {
  switch(action.type){
    case types.FETCH_CIP_GROUPS : 
    case types.FETCH_CIP_GROUPS_REJECTED:
      return {Groups:[], Loading : true};
    case types.FETCH_CIP_GROUPS_FULFILLED:
      var groups = action.payload.map((g, idx) => {
          return Object.assign(g, { label : g.Title, value : g.Id , className : 'cip-group-item' });
      });
      return {Groups : groups, Loading : false}
    default :
      return state;
  }
}


export const cipGroupManagers = (state = {Managers:[], Loading : true}, action) => {
  switch(action.type){
    case types.FETCH_CIP_GROUP_MANAGERS : 
    case types.FETCH_CIP_GROUP_MANAGERS_REJECTED:
      return {Managers:[], Loading : true};
    case types.FETCH_CIP_GROUP_MANAGERS_FULFILLED:
      var Managers = action.payload.map((u, idx) => {
          return Object.assign(u, { label : u.DisplayName, value : u.Id , className : '' });
      });
      return {Managers : Managers, Loading : false}
    default :
      return state;
  }
}

export const cipDepartments = (state = {Departments:[], Loading : true}, action) => {
  switch(action.type){
    case types.FETCH_CIP_DEPARTMENTS : 
    case types.FETCH_CIP_DEPARTMENTS_REJECTED:
      return {Departments:[], Loading : true};
    case types.FETCH_CIP_DEPARTMENTS_FULFILLED:
      var Departments = action.payload.map((u, idx) => {
          return Object.assign(u, { label : u.Title + ' - ' + u.Subtitle, value : u.Id , className : '' });
      });
      return {Departments : Departments, Loading : false}
    default :
      return state;
  }
}

export const currentCipGroup = (state = {Group : {Account : {}}, Loading : true, Members : [], Transactions :[]}, action) => {
  switch(action.type){
    case types.FETCH_CIP_GROUP : 
    case types.FETCH_CIP_GROUP_REJECTED:
      return {Group : {Account : {}}, Loading : true, Members : []};
    case types.FETCH_CIP_GROUP_FULFILLED:
      return {Group : action.payload, Loading : false, Members : []}
    case types.FETCH_CIP_MEMBERS : 
    case types.FETCH_CIP_MEMBERS_REJECTED:
      return Object.assign({}, state , {Loading : true, Members : []});
    case types.FETCH_CIP_MEMBERS_FULFILLED:
      return Object.assign({}, state , {Loading : false, Members : action.payload});

    case types.REMOVE_CIP_MEMBER : 
    case types.REMOVE_CIP_MEMBER_REJECTED:
      return Object.assign({}, state , {Loading : true});
    case types.REMOVE_CIP_MEMBER_FULFILLED:
      var Members =  state.Members.filter((m) => {
        return m.Id != action.payload.Id
      });
      return Object.assign({}, state , {Loading : false, Members : Members});
    
    
    case types.ADD_CIP_MEMBER : 
    case types.ADD_CIP_MEMBER_REJECTED:
      console.log(action.payload);
      return Object.assign({}, state , {Loading : true});
    case types.ADD_CIP_MEMBER_FULFILLED:
      var Members =  [...state.Members, (action.payload)];
      return Object.assign({}, state , {Loading : false, Members : Members});
    


    case types.SAVE_CIP_GROUP : 
    case types.SAVE_CIP_GROUP_REJECTED:
      return Object.assign({}, state , {Loading : true});
    case types.SAVE_CIP_GROUP_FULFILLED:
      return Object.assign({}, state , {Loading : false, Group : action.payload});
  
    
    case types.FETCH_CIP_GROUP_TRANSACTIONS : 
    case types.FETCH_CIP_GROUP_TRANSACTIONS_REJECTED:
      return Object.assign({}, state , {Loading : true, Transactions :[]});
    case types.FETCH_CIP_GROUP_TRANSACTIONS_FULFILLED:
      return Object.assign({}, state , {Loading : false, Transactions : action.payload});
    
    case types.SAVE_CIP_TRANSACTION : 
    case types.SAVE_CIP_TRANSACTION_REJECTED:
      return Object.assign({}, state , {Loading : true});
    case types.SAVE_CIP_TRANSACTION_FULFILLED:
      const t = action.payload;
      const Transactions = [...state.Transactions, t];
      return Object.assign({}, state , {Loading : false, Transactions : Transactions});
    default :
      return state;
  }
}




// WEBPACK FOOTER //
// ./reducers/cipGroupsReducer.js